module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_to-your-health_wp_2016_10_05_a-7-year-old-told-her-bus-driver-she-couldnt-wake-her-parents-police-found-them-dead-at-home__plot.0632baa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_to-your-health_wp_2016_10_05_a-7-year-old-told-her-bus-driver-she-couldnt-wake-her-parents-police-found-them-dead-at-home__plot.png
// module id = 436
// module chunks = 0